import type { Product } from "../products/types";

function formatGrade(grade: number): string {
  return grade.toFixed(1);
}

function gradeToPercent(grade: number): number {
  const clamped = Math.min(5, Math.max(1, grade));
  return ((5 - clamped) / 4) * 100;
}

function renderGradeBar(label: string, grade: number): string {
  const width = gradeToPercent(grade);

  return `
    <div class="metric">
      <div class="metric-row">
        <span>${label}</span>
        <strong>${formatGrade(grade)}</strong>
      </div>
      <div class="grade-track" role="img" aria-label="${label} Note ${formatGrade(grade)} von 5">
        <span class="grade-fill" style="width: ${width.toFixed(0)}%"></span>
      </div>
    </div>
  `;
}

export function renderCards(items: Product[]): string {
  return `
    <ul class="card-grid" role="list">
      ${items
        .map(
          (item) => `
          <li class="result-card">
            <a class="card-link" href="${item.detailUrl}" aria-label="Details zu ${item.name} oeffnen">
              <img src="${item.image}" alt="${item.name} Produktfoto" loading="lazy" />
              <div class="card-content">
                <p class="eyebrow">${item.category}</p>
                <h3>${item.name}</h3>
                <p class="meta">Marke: ${item.brand}</p>
                <p class="price">${item.price.toFixed(0)} ${item.currency}</p>
                <p class="meta">${item.isAvailable ? "Verfuegbar" : "Nicht verfuegbar"} | Testprogramm: ${item.testProgram}</p>
                <p class="meta">Veroeffentlicht: ${item.publicationDate} | Preisdatum: ${item.priceDate}</p>
                ${renderGradeBar("Gesamturteil", item.overall)}
                ${renderGradeBar("Handhabung", item.handling)}
                ${renderGradeBar("Sicherheit", item.safety)}
              </div>
            </a>
          </li>
        `
        )
        .join("")}
    </ul>
  `;
}
